import {
  ROUTE_LOGIN,
  ROUTE_MY_APPLICATIONS,
  ROUTE_MY_LEAGUE,
  ROUTE_MY_PROFILE,
  ROUTE_PLAY,
  ROUTE_REGISTER,
} from './routes';

// `text` alanları i18n key'leri tutar. Render tarafında (Header, MobileMenuDrawer)
// useTranslation + t(item.text) ile çözülür.
export const GUEST_MENU = [
  {
    text: 'common:nav.login',
    url: ROUTE_LOGIN,
    active: true,
    showDot: false,
  },
  {
    text: 'common:nav.register',
    url: ROUTE_REGISTER,
    active: true,
    showDot: false,
  },
];

export const MEMBER_MENU = [
  {
    text: 'common:nav.myProfile',
    url: ROUTE_MY_PROFILE,
    active: true,
    showDot: false,
  },
  {
    text: 'common:nav.myMatches',
    url: ROUTE_PLAY,
    active: true,
    showDot: true,
  },
  {
    text: 'common:nav.myOffers',
    url: '/tekliflerim',
    active: false,
    showDot: false,
  },
  {
    text: 'common:nav.offers',
    url: '/teklifler',
    active: false,
    showDot: false,
  },
  {
    text: 'common:nav.enterResult',
    url: '/sonuc-gir',
    active: false,
    showDot: false,
  },
  {
    text: 'common:nav.myLeague',
    url: ROUTE_MY_LEAGUE,
    active: true,
    showDot: false,
  },
  {
    text: 'common:nav.myApplications',
    url: ROUTE_MY_APPLICATIONS,
    active: true,
    showDot: true,
  },
  {
    text: 'common:nav.myPrizes',
    url: '/odullerim',
    active: false,
    showDot: false,
  },
  {
    text: 'common:nav.logout',
    url: '#',
    clickAction: 'signOut',
    active: true,
    showDot: false,
  },
];
